import * as _api2 from "@shapediver/api.geometry-api-dto-v2";
var _api = _api2;
try {
  if ("default" in _api2) _api = _api2.default;
} catch (e) {}
import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-core";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverResponseError = void 0;
const api_geometry_api_dto_v2_1 = _api;
const sdk_geometry_api_sdk_core_1 = _sdk;
class ShapeDiverResponseError extends sdk_geometry_api_sdk_core_1.ShapeDiverError {
  constructor(e) {
    super(e.message);
    this.errorType = sdk_geometry_api_sdk_core_1.ShapeDiverErrorType.Response;
    this.status = e.status;
    this.desc = e.desc;
    this.error = Object.values(api_geometry_api_dto_v2_1.ShapeDiverResponseErrorType).includes(e.error) ? e.error : api_geometry_api_dto_v2_1.ShapeDiverResponseErrorType.UNKNOWN;
  }
}
exports.ShapeDiverResponseError = ShapeDiverResponseError;
//# sourceMappingURL=ShapeDiverErrors.js.map
export default exports;